import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './ATFeedbackQuestion.scss';

class ATFeedbackQuestion extends React.Component {
    componentDidMount() {
    }

    onSelect = (optionId) => {
        const { form, field } = this.props;
        const values = Object.assign({}, form.values);
        values[field.name] = `${optionId}`;
        form.setValues(values);
    }
    render() {
        const {
            question,
            form,
            field,
        } = this.props;
        const values = Object.assign({}, form.values);

        const notLikely = {
            LAS: 'No es probable en absoluto',
        };

        const likely = {
            LAS: 'Extremadamente probables',
        };

        return (
            <React.Fragment>
                <p className="at-feedback-question-text">{question.text}</p>
                <div className="at-feedback-subtext">
                    <small>
                        {notLikely.ENG || 'Not at all likely'}
                    </small>
                    <small>
                        {likely.ENG || 'Extremely likely'}
                    </small>
                </div>
                <div className="btn-group">
                    {question.options.map((option, index) => (
                        <button
                            type="button"
                            onClick={() => this.onSelect(option.id)}
                            className={classNames({
                                'first-button': index === 0,
                                'last-button': index === question.options.length - 1,
                                active: values[field.name] === `${option.id}`,
                            })}
                            key={option.id}
                        >{option.text}
                        </button>
                    ))}
                </div>
            </React.Fragment>
        );
    }
}

ATFeedbackQuestion.propTypes = {
    question: PropTypes.shape({}).isRequired,
    field: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({}),
        ]),
    }).isRequired,
    form: PropTypes.shape({
        errors: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.shape({}),
            PropTypes.string,
        ])),
        touched: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({}),
        ])),
    }).isRequired,
};

const mapStateToProps = state => ({
    assessmentLanguage: state.assessment.language,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ATFeedbackQuestion);
